// extracted by mini-css-extract-plugin
export var cartIcon = "_pg-0";
export var cartIconContainer = "_pg-1";